import SIDEBAR from '@/graphql/gql/local/sidebar.gql';
import TOGGLE_SIDEBAR from '@/graphql/gql/local/mutations/toggleSidebar.gql';
import { computed } from 'vue';
import { useMutation, useQuery } from '@vue/apollo-composable';
import { graphql } from '@/__generated__';
import { Sidebar } from '@/__generated__/graphql';

export default {
  methods: {
    closeSidebar(type) {
      if (this.sidebar[type]) {
        this.$apollo.mutate({
          mutation: TOGGLE_SIDEBAR,
          variables: {
            sidebar: {
              [type]: false,
            },
          },
        });
      }
    },
  },

  apollo: {
    sidebar: {
      query: SIDEBAR,
    },
  },

  data: () => ({
    sidebar: {
      profile: false,
      navigation: false,
    },
  }),
};

export function useSidebar() {
  const { result } = useQuery(
    graphql(`
      query SidebarClientQuery {
        sidebar @client {
          profile
          navigation
        }
      }
    `)
  );

  const { mutate: mutateToggleSidebar } = useMutation(
    graphql(`
      mutation SidebarMutation($sidebar: SidebarInput!) {
        toggleSidebar(sidebar: $sidebar) @client {
          profile
          navigation
        }
      }
    `)
  );

  const sidebar = computed<Sidebar>(() => result.value?.sidebar || { profile: false, navigation: false });

  type ToggleSidebarArgumentType = 'navigation' | 'profile';

  const closeSidebar = (type: ToggleSidebarArgumentType) => {
    if (sidebar.value[type]) {
      mutateToggleSidebar({
        sidebar: {
          [type]: false,
        },
      });
    }
  };

  const openSidebar = (type: ToggleSidebarArgumentType) => {
    mutateToggleSidebar({
      sidebar: {
        [type]: true,
      },
    });
  };

  return { sidebar, closeSidebar, openSidebar };
}
